// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const EpicIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="EpicIcon" ref={forwardedRef} {...props}>
      <path d="m12.393 1.836-7.179 9.523h3.678l-1.285 6.805 7.179-9.515-3.534-.005z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const EpicIcon = /* @__PURE__ */ Object.assign(EpicIconComponent, {
  displayName: 'EpicIcon',
});
